import React from 'react';
import {render} from 'react-dom';
import './styles/search-result.scss';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import SearchResultBase from "./SearchResultBase";

const router = createBrowserRouter([
    {
        path: "/search-result",
        element: <SearchResultBase/>,
    },
]);

document.addEventListener('DOMContentLoaded', () => {
    const entry = document.querySelector('#search-result');
    render(<RouterProvider router={router}/>, entry);
});
